import fetchJsonp from 'fetch-jsonp';
import { imdbSearchResultDto } from './components/search/search-bar.slice';

export interface imdbSearchResponseDto {
  v: number;
  q: string;
  d: imdbSearchResultDto[];
}

export const getSearchResults = (searchTerm: string): Promise<imdbSearchResponseDto> => {
  const query = searchTerm.replace(/ /g,"_"); // replace spaces with underscores
  const letter = query[0].toLowerCase();

  return fetchJsonp(`https://sg.media-imdb.com/suggests/${letter}/${query}.json`, {
      jsonpCallbackFunction: 'imdb$' + query,
    })
    .then(function(response) {
      return response.json()
    });
}



export interface imdbEpisodeDetailsDto {
  id: string;
  title: string;
  rating: number;
}

export interface imdbSeasonDetailsDto {
  averageRating: number;
  episodes: {
    [key: number]: imdbEpisodeDetailsDto
  };
}

export interface imdbShowDetailsDto {
  data: {
    id: string;
    title: string;
    views: number;
    episodesPerSeason: number;
    highestRating: number;
    lowestRating: number;
    updated: string;
    seasons: {
      [key: number]: imdbSeasonDetailsDto
    };
  };
}

export const getShowDetails = (id: string): Promise<imdbShowDetailsDto> => {
  return fetch(`https://redd38.com/api/imdb/title/${id}`)
    .then(function(response) {
      return response.json()
    });
}



export const updateShowViewCount = (id: string, coverImage: string) => {
  const body = coverImage ? {id, coverImage} : {id};

  return fetch(`https://redd38.com/api/imdb/view`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(body)
  });
}



export interface showBasicInfo {
  id: string;
  title: string;
  views: number;
  episodesPerSeason: number;
  highestRating: number;
  lowestRating: number;
  ratingsCount: number;
  coverImage: string;
  lastViewed: string;
  updated: string;
}

export interface recentShowsDto {
  data: showBasicInfo[];
}

export const getRecentShows = (): Promise<recentShowsDto> => {
  return fetch(`https://redd38.com/api/imdb/recent`)
  .then(function(response) {
    return response.json()
  });
}